<template>
  <component :is="getCurrentCard(cardData.type)" :type="type" :cardData="cardData"/>
</template>

<script>
import cardHeading from '@/components/periple/cards/cardHeading.component.vue';
import cardArticlePeriple from '@/components/periple/cards/cardArticlePeriple.component.vue';

export default {
  components: {
    cardHeading,
    cardArticlePeriple,
  },
  props: {
    type: {
      type: String,
      default: () => 'normal',
    },
    cardData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    function getCurrentCard(type) {
      switch (type) {
        case 'info_sheet':
          return 'cardArticlePeriple';

        case 'dossier_thematic':
          return 'cardArticlePeriple';

        case 'ext_links':
          return 'cardArticlePeriple';

        case 'video':
          return 'cardArticlePeriple';

        case 'etr_heading':
          return 'cardHeading';

        default:
          return '';
      }
    }

    return {
      getCurrentCard,
    };
  },
};
</script>
